import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

export const getProduct = createAsyncThunk(
  "/productdetails",
  async (data, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Product.Product_Detail, data);

      if (res?.success === false) {
        return rejectWithValue(res);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: error.message },
      );
    }
  },
);

export const addAddress = createAsyncThunk(
  "/user/userstoreAddress",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Product.addAddress, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllAddress = createAsyncThunk(
  "/user/getaddress",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Product.getAllAddress);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetSinglelAddress = createAsyncThunk(
  "/user/getaddressbyid",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Product.GetSinglelAddress}?id=${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const updateAddress = createAsyncThunk(
  "/user/updateUserAddress",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await POST(`/user/updateUserAddress?id=${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const deleteAddress = createAsyncThunk(
  "/user/deleteUserAddress",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`/user/deleteUserAddress?id=${id}`);
      return { id, res }; // return id so we can remove it from state
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// export const postOrder = createAsyncThunk(
//   "/place-order",
//   async (data, { rejectWithValue }) => {
//     try {
//       const res = await POST(APIS.Product.postOrder, data);
//       return res;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   },
// );

export const postOrder = createAsyncThunk(
  "/place-order",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Product.postOrder, data);

      // 👇 handle backend success false here
      if (res?.success === false) {
        return rejectWithValue(res); // send full response
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Something went wrong" },
      );
    }
  },
);

export const getOrder = createAsyncThunk(
  "/getOrder",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Product.getOrder);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllOrder = createAsyncThunk(
  "/user/orderHistory",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Product.getAllOrder);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const subscriptionSlice = createSlice({
  name: "productdetails",
  initialState: {
    products: [],
    all_user_address: [],
    get_order: {},
    get_order_history: [],
    single_address: null,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getProduct.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(getProduct.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.products = action.payload?.data || [];
      })
      .addCase(getProduct.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload?.message;
      })

      .addCase(addAddress.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(addAddress.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload.data;
      })
      .addCase(addAddress.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(getAllAddress.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(getAllAddress.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_user_address = action.payload || [];
      })
      .addCase(getAllAddress.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSinglelAddress.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      // .addCase(GetSinglelAddress.fulfilled, (state, action) => {
      //   state.status = IDS.SLICESTATUS.Succeeded;
      // })
      .addCase(GetSinglelAddress.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.single_address = action.payload?.data?.[0] || null;
      })
      .addCase(GetSinglelAddress.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(updateAddress.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(updateAddress.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        // update the edited address in list
        const index = state.all_user_address.findIndex(
          (addr) => addr.id === action.payload?.data?.id,
        );

        if (index !== -1) {
          state.all_user_address[index] = action.payload.data;
        }
      })
      .addCase(updateAddress.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(deleteAddress.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(deleteAddress.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        // remove deleted address from list
        state.all_user_address = state.all_user_address.filter(
          (addr) => addr.id !== action.payload.id,
        );
      })
      .addCase(deleteAddress.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(postOrder.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(postOrder.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload.data;
      })
      .addCase(postOrder.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(getOrder.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(getOrder.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.get_order = action.payload || [];
      })
      .addCase(getOrder.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(getAllOrder.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(getAllOrder.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.get_order_history = action.payload || [];
      })
      .addCase(getAllOrder.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default subscriptionSlice.reducer;
